/** Menu category anchor for Packs (matches menu section id / hamburger #packs). */
export const GIFTING_MENU_PACKS_SECTION_LINK = '/menu#packs';

/** Default copy and CTA for GiftingSeasonalPromoBrandRefresh; override via props when CMS is wired. */
export const GIFTING_SEASONAL_PROMO_DEFAULT = {
  headlineLineOne: 'They just moved ',
  headlineLineTwo: 'into the dorm,',
  headlineAccent: ' send backup.',
  body:
    "Insomnia delivers to campuses nationwide. Send a care package they'll brag about, available late (exactly when homesickness hits).",
  ctaText: 'Order a Pack',
  ctaLink: GIFTING_MENU_PACKS_SECTION_LINK,
  ctaButtonType: 'internal_link',
  stickerAlt: 'Back to school promotion',
  contentSection: 'Gifting LP — Seasonal Promo',
};
